var map = {
	"./ABC_logo.png": 30493,
	"./FOUROAKS_logo.png": 53679,
	"./SRG_logo.png": 66579,
	"./SRG_logo1s.png": 3619,
	"./SRG_logo4.png": 70911,
	"./iNube_logo.png": 88634,
	"./login.png": 19340
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73811;